var ausStates = [
    {
        name: 'Australian Capital Territory',
        id: 'ACT',
    },
    {
        name: 'New South Wales',
        id: 'NSW',
    },
    {
        name: 'Northern Territory',
        id: 'NT',
    },
    {
        name: 'Queensland',
        id: 'QLD',
    },
    {
        name: 'South Australia',
        id: 'SA',
    },
    {
        name: 'Tasmania',
        id: 'TAS',
    },
    {
        name: 'Victoria',
        id: 'VIC',
    },
    {
        name: 'Western Australia',
        id: 'WA'
    }
];
export default ausStates;
